import { Info } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type SnapshotModeInfoProps = {
  label: string;
  hint: string;
};

/** Label plus an info icon. Hovering the icon explains the option. */
export function SnapshotModeInfo({ label, hint }: SnapshotModeInfoProps) {
  return (
    <span className="tw:inline-flex tw:items-center tw:gap-1">
      <span>{label}</span>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger
            render={
              <span
                aria-label={`About ${label}`}
                className="tw:inline-flex tw:text-muted-foreground"
              >
                <Info className="tw:size-3.5" />
              </span>
            }
          />
          <TooltipContent className="dark">{hint}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </span>
  );
}
